<template>
  <div>
    <div class="products" v-if="products.length > 0">
      <Slick ref="slick" :options="slickOptions">
        <template v-for="product of products">
          <ProductsCardItem
            v-if="product.Terms.length > 0"
            :key="product.id"
            :title="product.name"
            :image="product.image"
            @handleClickCardItem="onClickCardItem(product.id)"
          />
        </template>

        <ProductsCardItem v-for="index in allocate" :key="index + '-filler'" />
      </Slick>
    </div>
    <Spinner v-else :theme="primary" />
  </div>
</template>

<script>
import ProductsCardItem from "@/components/booking/ProductsCardItem";
import axios from "@/helpers/axios";
import Spinner from "@/components/Spinner";
import Slick from "vue-slick";

export default {
  components: {
    ProductsCardItem,
    Slick,
    Spinner
  },
  props: ["data"],
  data() {
    return {
      slickOptions: {
        slidesToShow: 2,
        arrows: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      },
      config: {
        page: 1,
        size: 10
      },
      products: [],
      allocate: 3
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  mounted() {
    this.fetchProducts(this.config);
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    fetchProducts({ page, size }) {
      const { locationId, categoryId } = this.data;
      axios
        .get(
          `/products?page[number]=${page}&page[size]=${size}&locationId=${locationId}&categoryId=${categoryId}&status=2`
        )
        .then(response => {
          const { data: products, meta } = response.data;
          this.products = [
            ...this.products,
            ...products.filter(product => product.Terms.length > 0)
          ];
          const all = 3 - this.products.length;
          this.allocate = all > 0 ? all : 0;
          if (meta.hasNextPage) {
            this.fetchProducts(page + 1);
          }
        });
    },
    onClickCardItem(productId) {
      this.$emit("next", { productId: productId });
    }
  }
};
</script>

<style lang="scss">
.slick {
  margin: 0;
  &-slide {
    margin: 0 5px;
  }
  &-disabled {
    color: $gray-500;
    cursor: initial !important;
    background: white !important;
    &:hover {
      background: white !important;
    }
  }
  &-arrow {
    position: absolute;
    height: 30px;
    width: 30px;
    top: calc(50% - 30px);
    border: 1px solid #dedede;
    background: white;
    overflow: hidden;
    border-radius: 90%;
    font-size: 18px;
    cursor: pointer;
    z-index: 1;
    &:hover {
      background: $gray-400;
    }
  }
  @media (min-width: 767px) {
    &-prev {
      left: -35px !important;
    }
    &-next {
      right: -35px !important;
    }
  }
  &-next {
    right: -20px;
    &::before {
      content: ">";
      display: block;
    }
  }
  &-prev {
    left: -20px;
    &::before {
      content: "<";
      display: block;
    }
  }
}
</style>
